var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceivementLightBlueNoBgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70659 0C6.93808 0 7.12575 0.223858 7.12575 0.5V9.29289L9.90321 5.97978C10.0669 5.78452 10.3323 5.78452 10.496 5.97978C10.6597 6.17504 10.6597 6.49162 10.496 6.68689L7.00298 10.8536C6.83929 11.0488 6.57389 11.0488 6.41019 10.8536L2.91718 6.68689C2.75349 6.49162 2.75349 6.17504 2.91718 5.97978C3.08087 5.78452 3.34627 5.78452 3.50996 5.97978L6.28743 9.29289V0.5C6.28743 0.223858 6.47509 0 6.70659 0ZM0.419162 10C0.650658 10 0.838323 10.2239 0.838323 10.5V13.8333C0.838323 14.1428 0.941367 14.4395 1.12479 14.6583C1.3082 14.8771 1.55697 15 1.81637 15H11.5968C11.8562 15 12.105 14.8771 12.2884 14.6583C12.4718 14.4395 12.5749 14.1428 12.5749 13.8333V10.5C12.5749 10.2239 12.7625 10 12.994 10C13.2255 10 13.4132 10.2239 13.4132 10.5V13.8333C13.4132 14.408 13.2218 14.9591 12.8812 15.3654C12.5405 15.7717 12.0785 16 11.5968 16H1.81637C1.33464 16 0.872636 15.7717 0.532002 15.3654C0.191367 14.9591 0 14.408 0 13.8333V10.5C0 10.2239 0.187665 10 0.419162 10Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivementLightBlueNoBgOutline);
export default __webpack_public_path__ + "static/media/receivementLightBlueNoBgOutline.9c9d926086adcc471b8f65b11affb175.svg";
export { ForwardRef as ReactComponent };